import React from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { GeneralSettingsTab } from '@/components/site-settings/GeneralSettingsTab';
import { SEOSettingsTab } from '@/components/site-settings/SEOSettingsTab';
import { EmailSettingsTab } from '@/components/site-settings/EmailSettingsTab';
import { AdvancedSettingsTab } from '@/components/site-settings/AdvancedSettingsTab';
import { MaintenanceTab } from '@/components/site-settings/MaintenanceTab';
import { SecuritySettingsTab } from '@/components/site-settings/SecuritySettingsTab';

export const SiteSettingsPage = () => {
  return (
    <div>
      <PageHeader
        title="Site Settings"
        description="Configure global site settings and preferences"
        breadcrumbs={['Admin', 'System', 'Site Settings']}
      />

      <Tabs defaultValue="general" className="space-y-6">
        <TabsList>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="seo">SEO</TabsTrigger>
          <TabsTrigger value="email">Email</TabsTrigger>
          <TabsTrigger value="advanced">Advanced</TabsTrigger>
          <TabsTrigger value="maintenance">Maintenance</TabsTrigger>
          <TabsTrigger value="security">Security</TabsTrigger>
        </TabsList>

        <TabsContent value="general">
          <GeneralSettingsTab />
        </TabsContent>

        <TabsContent value="seo">
          <SEOSettingsTab />
        </TabsContent>

        <TabsContent value="email">
          <EmailSettingsTab />
        </TabsContent>

        <TabsContent value="advanced">
          <AdvancedSettingsTab />
        </TabsContent>

        <TabsContent value="maintenance">
          <MaintenanceTab />
        </TabsContent>

        <TabsContent value="security">
          <SecuritySettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
